// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2ij3M","error":"Textarea_error__3HfRj","readonly":"Textarea_readonly__Bl6w9","disabled":"Textarea_disabled__2ieES"};